import { BLOOMREACH_ACCOUNT_ID, IS_BLOOMREACH_TEST_ENV } from '@/services/Configuration'
import type { BreadcrumbsType } from '@/types/ElasticSearch/SearchAPIResponse'
import type { Product } from '@/types/Product'
import type { StandardLineItem } from '@/types/ShopFront/CheckoutStandards'

const generateBloomreachBaseScript = (customScript?: string) => {
  const baseScript = `
    var brtrk = document.createElement('script');
    brtrk.type = 'text/javascript';
    brtrk.async = true;
    brtrk.src = "//cdn.brcdn.com/v1/br-trk-${BLOOMREACH_ACCOUNT_ID}.js";
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(brtrk, s);
    var br_data = br_data || {};
    br_data.acct_id = ${BLOOMREACH_ACCOUNT_ID};
    br_data.test_data = '${IS_BLOOMREACH_TEST_ENV}';
  `
  return customScript ? `${baseScript} ${customScript}` : baseScript
}
export const bloomreachConversionEvent = (
  customerId : number,
  orderId: string,
  orderTotal: number,
  lineItems: StandardLineItem[],
) => {
  const updatedLineItems = lineItems.map(({
    sku: prod_id,
    sku,
    subtotalPrice: price,
    ...rest
  }) => ({
    prod_id,
    sku,
    price,
    ...rest,
  }))
  const bloomreachScript = document.createElement('script')
  bloomreachScript.setAttribute('type', 'text/javascript')
  bloomreachScript.textContent = `
          ${generateBloomreachBaseScript()}
          br_data.ptype = 'other'
          br_data.user_id = ${customerId}
          br_data.is_conversion = ${1}
          br_data.basket_value = ${orderTotal}
          br_data.order_id = ${orderId}
          br_data.basket = {
          'items':
           ${JSON.stringify(updatedLineItems)}
          ,
        };`
  document.body.appendChild(bloomreachScript)
}
export const bloomreachSearchPagePixel = (
  title,
  userId,
) => {
  const bloomreachScript = document.createElement('script')
  bloomreachScript.setAttribute('type', 'text/javascript')
  bloomreachScript.setAttribute('id', 'SearchPageViewPixel')
  bloomreachScript?.parentNode?.removeChild(bloomreachScript)

  bloomreachScript.textContent = `
          ${generateBloomreachBaseScript()}
          br_data.ptype = "search";
          br_data.user_id = '${userId}';
          br_data.search_term = '${title}'; 
        `
  document.body.appendChild(bloomreachScript)
}

export const bloomreachSearchEvent = (
  searchString: string,
) => {
  if (window.BrTrk) {
    const searchData : { q: string
      catalogs: { name : string }[] } = {
      q: '',
      catalogs: [],
    }
    searchData.q = searchString
    searchData.catalogs = [{ 'name': 'onekingslane' }]
    window.BrTrk?.getTracker?.().logEvent('suggest', 'submit', searchData, {}, true)
  }
}

export const bloomreachAddToCartEvent = (
  sku: string,
) => {
  if (window.BrTrk) {
    window.BrTrk?.getTracker?.().logEvent('cart', 'click-add', { 'prod_id': sku, 'sku': sku })
  }
}

export const bloomreachPageViewPixel = (
  product : Product | undefined,
  customerId : number | undefined,
  sku : string | undefined,
) => {
  if (!product) {
    return
  }
  const bloomreachScript = document.createElement('script')
  bloomreachScript.setAttribute('id', 'PDPPixelScript')
  bloomreachScript.textContent = `
      ${generateBloomreachBaseScript()}
      if (document.referrer !== document.location.href){
            br_data.ptype = "product";
            br_data.prod_name = '${product?.name}';
            br_data.prod_id = '${sku}';
            br_data.user_id = '${customerId}';
            br_data.sku = '${sku}';
          }`
  const script = document.getElementById('PDPPixelScript')
  if (script === null) {
    document.body.appendChild(bloomreachScript)
  }
}

export const bloomreachContentPageViewPixel = (
  pageTitle?,
) => {
  const bloomreachScript = document.createElement('script')
  bloomreachScript.textContent = `
          ${generateBloomreachBaseScript()}
          br_data.catalogs = [ { name : 'onekingslane_discovery' } ];
          br_data.item_name = '${pageTitle}';
          br_data.ptype = "content";
        `
  document.body.appendChild(bloomreachScript)
}

export const bloomreachSuggestEventPixel = (
  searchString: string | RegExp,
  searchSuggestion: string,
) => {
  const searchData : { q: string, aq: string | RegExp,
    catalogs: { name : string }[] } = {
    q: '',
    aq: '',
    catalogs: [],
  }
  searchData.q = searchSuggestion
  searchData.aq = searchString
  searchData.catalogs = [{ 'name': 'onekingslane' }]

  if (window.BrTrk) {
    window.BrTrk?.getTracker?.().logEvent('suggest', 'click', searchData, {}, true)
  }
}

export const bloomreachCategoryPagePixel = (
  breadcrumbs?: BreadcrumbsType[],
) => {
  if (!breadcrumbs) {
    return
  }
  const bloomreachScript = document.createElement('script')
  bloomreachScript.setAttribute('type', 'text/javascript')
  bloomreachScript.textContent = `
  if (document.referrer !== document.location.href){
        ${generateBloomreachBaseScript()}
          br_data.ptype = "category";
          br_data.cat_id = ${breadcrumbs?.slice(-1)[0].id};
          br_data.cat = '${breadcrumbs?.map((obj) => obj.id).join('|')}';
  }`
  document.body.appendChild(bloomreachScript)
}

export const bloomreachHomePagePixel = () => {
  const bloomreachScript = document.createElement('script')
  bloomreachScript.setAttribute('type', 'text/javascript')
  bloomreachScript.textContent = `
  if (document.referrer !== document.location.href){
        ${generateBloomreachBaseScript()}
          br_data.ptype = "homepage";  }`
  document.body.appendChild(bloomreachScript)
}
